import { ViewModel,View } from "binder"
import  { EmptyWindowView } from "./emptyWindow-view"
import { WindowViewModel } from "../windowContainer/windowContainer-viewModel";

export class EmptyWindowViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'پنجره تایید';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new EmptyWindowView();
    }
    public getTypeId(): string {
        return "VM-E312D559-3140-4193-A518-FA44B177833C"
    }
}
